import { Heading, List, ListItem, Stack } from '@chakra-ui/react';
import { Children, ReactNode } from 'react';

export type ToolsListProps = {
  children?: ReactNode;
};

export const ToolsList = ({ children }: ToolsListProps) => (
  <Stack spacing={4} w="full">
    <Heading fontSize="xl" color="brand.primary.swatch1">
      Team Captain Tools
    </Heading>
    <List spacing={4}>
      {Children.map(children, (child) => (
        <ListItem>{child}</ListItem>
      ))}
    </List>
  </Stack>
);
